import { render, staticRenderFns } from "./AddFeatureForm.vue?vue&type=template&id=605d91cf&scoped=true&"
import script from "./AddFeatureForm.vue?vue&type=script&lang=js&"
export * from "./AddFeatureForm.vue?vue&type=script&lang=js&"
import style0 from "./AddFeatureForm.vue?vue&type=style&index=0&id=605d91cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d91cf",
  null
  
)

export default component.exports